import React, { useState } from 'react';

import { Grid } from '@material-ui/core';
import { loadConnectAndInitialize, StripeConnectInstance } from '@stripe/connect-js';
import {
  ConnectComponentsProvider,
  ConnectPayments,
  ConnectPayouts,
} from '@stripe/react-connect-js';

import Config from 'config/Config';
import { paymentsModel } from 'models';
import { COLORS } from 'theme/constants';

import { Subtext } from '../AnalyticsProviders/GoogleTagManager/style';
import { WidgetTitle } from './style';

interface StripeConnectedAccountWidgetsProps {
  getT: (key: string) => string;
  onError: (message: string) => void;
}

const fetchClientSecret = () => paymentsModel.createAccountSession().then(({ clientSecret }) => clientSecret);

const initConnect = (): StripeConnectInstance | null => {
  if (!Config.stripe_public_key) {
    return null;
  }

  return loadConnectAndInitialize({
    publishableKey: Config.stripe_public_key,
    fetchClientSecret,
    appearance: {
      variables: {
        colorPrimary: COLORS.cozmosBlue,
        fontFamily: 'Inter, Nunito, sans-serif',
        borderRadius: '8px',
      },
    },
  });
};

const StripeConnectedAccountWidgets = ({ getT, onError }: StripeConnectedAccountWidgetsProps) => {
  const [connectInstance] = useState(initConnect);

  if (!connectInstance) {
    return (
      <Grid item xs={12}>
        <Subtext>{getT('widgetsUnavailable')}</Subtext>
      </Grid>
    );
  }

  const handleLoadError = ({ error }: { error: { message?: string } }) =>
    onError(error.message || getT('widgetLoadError'));

  return (
    <ConnectComponentsProvider connectInstance={connectInstance}>
      <Grid item xs={12}>
        <WidgetTitle>{getT('paymentsTitle')}</WidgetTitle>
        <ConnectPayments onLoadError={handleLoadError} />
      </Grid>
      <Grid item xs={12}>
        <WidgetTitle>{getT('payoutsTitle')}</WidgetTitle>
        <ConnectPayouts onLoadError={handleLoadError} />
      </Grid>
    </ConnectComponentsProvider>
  );
};

export default StripeConnectedAccountWidgets;
